import useSWR from 'swr';
import { analyticsService, SparePartsResponse } from '../services/analyticsService';

interface UseAnalyticsSparePartsReturn {
  spareParts: SparePartsResponse | undefined;
  loading: boolean;
  error: Error | undefined;
}

export const useAnalyticsSpareParts = (year: number): UseAnalyticsSparePartsReturn => {
  const { data, error, isLoading } = useSWR<SparePartsResponse, Error>(
    `/api/v1/analytics/service/spare-parts?year=${year}`,
    () => analyticsService.getSpareParts(year),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    spareParts: data,
    loading: isLoading,
    error,
  };
};
